
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-refund-terms",
      function () {
        return require("private-next-pages/delivery-refund-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-refund-terms"])
      });
    }
  